var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x32_7_x2C__PDF_x2C__File_type_x2C__Adobe"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "367.309,53.245 426.374,112.496 426.146,112.714 367.811,112.758 367.266,53.289   ",
    style: {
      fill: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.747,146.766c0,11.242-6.28,16.552-15.919,16.476c-1.319,0-2.792,0-3.696-0.207v-30.782    c0.904-0.207,2.442-0.425,4.819-0.425C203.088,131.829,208.813,136.997,208.747,146.766z",
    style: {
      fill: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.131,138.6c0,4.819-3.49,7.687-9.137,7.687c-1.538,0-2.661-0.076-3.566-0.283v-13.892    c0.774-0.207,2.235-0.414,4.394-0.414C158.132,131.698,161.131,134.271,161.131,138.6z",
    style: {
      fill: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,94.625h183.182v105.766H125.65h-0.447H86.396V94.625h38.806H125.65z",
    style: {
      fill: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.182,254.997c0.13,10.98-6.892,32.405-6.892,32.405c-2.422-2.551-7.263-16.203-7.263-28.83    c0-12.626,4.079-16.071,7.263-16.071C277.484,242.501,281.049,244.028,281.182,254.997z",
    style: {
      fill: "#DC1D00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.638,350.754c0,14.502-26.278,8.591-42.438-6.794    C315.2,343.96,357.638,336.262,357.638,350.754z",
    style: {
      fill: "#DC1D00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.149,398.512c-13.008-7.785,27.303-31.763,34.576-32.525    C239.725,365.986,218.768,406.656,205.149,398.512z",
    style: {
      fill: "#DC1D00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.417,311.26c7.394,13.772,22.069,29.975,22.069,29.975s-5.616,0.633-18.666,3.827    c-13.053,3.194-19.605,6.51-19.605,6.51s0,0,5.354-11.994C274.933,327.583,280.417,311.26,280.417,311.26z",
    style: {
      fill: "#DC1D00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.593,112.714V458.81H125.65V200.391h183.182V94.625H125.65V53.191h241.616l0.043,0.054    l-0.043,0.043l0.545,59.469l58.335-0.044l0.229-0.218L426.593,112.714z",
    style: {
      fill: "#DC1D00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.725,365.986c-7.272,0.763-47.584,24.74-34.576,32.525    C218.768,406.656,239.725,365.986,239.725,365.986z M315.2,343.96c16.159,15.385,42.438,21.296,42.438,6.794    C357.638,336.262,315.2,343.96,315.2,343.96z M302.486,341.234c0,0-14.676-16.202-22.069-29.975c0,0-5.484,16.323-10.849,28.317    c-5.354,11.994-5.354,11.994-5.354,11.994s6.553-3.315,19.605-6.51C296.87,341.867,302.486,341.234,302.486,341.234z     M274.29,287.402c0,0,7.021-21.425,6.892-32.405c-0.133-10.969-3.697-12.496-6.892-12.496c-3.184,0-7.263,3.445-7.263,16.071    C267.027,271.199,271.868,284.852,274.29,287.402z M283.1,303.987c7.143,15.439,26.791,35.328,26.791,35.328    s6.368-1.657,32.646-2.289c26.288-0.633,27.434,14.152,27.553,15.428c0.131,1.287,1.157,13.02-19.768,13.782    c-20.913,0.764-42.611-21.044-42.611-21.044s-8.92,1.406-16.313,3.185c-7.393,1.787-31.13,8.297-31.13,8.297    s-7.022,12.757-22.582,33.158c-15.57,20.412-33.005,18.886-37.978,12.124c-5.779-7.85-1.319-15.688,9.65-25.896    c10.969-10.205,36.277-18.667,36.277-18.667s5.103-9.181,12.583-26.703c7.479-17.522,13.139-35.121,13.139-35.121    s-7.404-16.813-8.844-31.119c-1.613-15.952,0.175-26.67,12.42-26.801c12.246-0.131,16.072,9.061,16.454,25.001    C291.768,278.604,283.1,303.987,283.1,303.987z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "255,133 255,124 227,124 227,171 237,171 237,152 254,152 254,144 237,144 237,133    ",
    style: {
      fill: "#A51600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.094,128.688c-4.536-3.424-10.548-5.027-19.489-5.027c-5.375,0-10.605,0.349-14.605,0.981     v46.21c3,0.349,6.787,0.697,12.304,0.697c9.214,0,16.871-1.952,21.821-6.073c4.536-3.838,7.874-10.054,7.874-19.06     C219.999,138.12,216.99,132.319,212.094,128.688z M192.262,163.242c-1.319,0-2.262,0-4.262-0.207v-30.782     c2-0.207,3.008-0.425,5.386-0.425c9.137,0,14.861,5.168,14.795,14.938C208.181,158.008,201.9,163.318,192.262,163.242z",
    style: {
      fill: "#A51600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.648,127.434c-3.14-2.519-8.259-3.772-14.824-3.772c-6.488,0-11.824,0.425-14.824,0.981V171     h11v-16.765c1,0.142,2.449,0.218,3.846,0.218c6.28,0,11.762-1.538,15.394-4.961c2.791-2.649,4.381-6.564,4.381-11.165     C171.621,133.715,169.646,129.811,166.648,127.434z M151.779,146.287c-1.537,0-2.779-0.076-3.779-0.283v-13.892     c1-0.207,2.449-0.414,4.607-0.414c5.311,0,8.309,2.573,8.309,6.902C160.916,143.419,157.427,146.287,151.779,146.287z",
    style: {
      fill: "#A51600"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ba40f5ff4bf578c3f28477e160fa5168.svg";
export { ForwardRef as ReactComponent };